import {Component, input, output} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';

/**
 * A close cross in a ring that empties over `duration`, clockwise from the top (KAB-2441): `closed` emits on the click or
 * at the end. The cross takes the host's `color`, the ring `--countdown-close-ring-color`.
 */
@Component({
	selector: 'app-countdown-close-button',
	imports: [TranslatePipe],
	template: `
		<button type="button" [attr.aria-label]="'global.close' | translate" (click)="closed.emit()">
			<svg viewBox="0 0 24 24" aria-hidden="true">
				<circle class="countdown" cx="12" cy="12" r="11" pathLength="100" [style.animation-duration.ms]="duration()" (animationend)="closed.emit()"/>
				<path d="M8.5 8.5L15.5 15.5M15.5 8.5L8.5 15.5"/>
			</svg>
		</button>
	`,
	styleUrl: './countdown-close-button.component.scss',
})
export class CountdownCloseButtonComponent {
	/** Milliseconds before it closes by itself. */
	readonly duration = input.required<number>();
	readonly closed = output<void>();
}
